@if (!isInFolder()) {
    <app-realized-work-page-header [form]="form"></app-realized-work-page-header>
}

<app-table
    tableKey="movementRestrictions"
    [gridData]="$any(store.data.getWorks())"
    [transformItem]="workHideDelete()"
    [columns]="columns()"
    translatePrefix="workData.movementRestriction."
    [showSearch]="true"
    [showColumnVisiblity]="true"
    [showExport]="true"
    (deleteCallbackWithEvent)="delete($event)"
    (detailCallback)="detail($event)"
    [additionalFilter]="extraFilters()"
    [refreshCallback]="store.api.getWorks"
    [refreshCallbackFragment]="getWorksFrag"
    [defaultSorters]="[{ column: 'dateFrom', direction: 'DESC' }]"
>

    <ng-template pTemplate="print" let-item="item">
        <app-button
            icon="pi-print"
            severity="primary"
            [text]="true"
            styleClass="tableIcon"
            (clickEvent)="print(item)"
        ></app-button>
    </ng-template>

    <ng-template pTemplate="send" let-item="item">
        <app-button
            icon="pi-send"
            severity="primary"
            [text]="true"
            styleClass="tableIcon"
            (clickEvent)="send(item)"
        ></app-button>
    </ng-template>

    <ng-template pTemplate="emailHistory" let-data="data" let-item="item">
        <app-work-email-history-table-column [emails]="data" [type]="item.workType"
            [typeId]="item.id"></app-work-email-history-table-column>
    </ng-template>

    <ng-template pTemplate="footer" let-items="items" let-columns="columns">
        <tr>
            <td>{{ 'summary' | translate }}:</td>
            <td></td>
            @for (col of columns; track col.name) {
                <td>
                    @if (col.name === 'dateFrom') {
                        <span>{{ 'database.workVisits.uniqueDates' | translate }}{{ items | workUniqueDays }}</span>
                    } @else if (col.name === 'users') {
                        <span>{{ 'database.workVisits.uniqueWorkers' | translate }}{{ items | workUniques: 'users' }}</span>
                    } @else if (col.name === 'folder') {
                        <span>{{ 'database.workVisits.uniqueFolders' | translate }}{{ items | workUniques: 'folderId' }}</span>
                    }
                </td>
            }
        </tr>
    </ng-template>
</app-table>
